$(function(){
  product_data = $('#productJson').text();
  product_data = JSON.parse(product_data);
  
  change_variant();
  $('select[data-toggle="variant"]').on('change',function(){
    change_variant();
  });

  //mutationObserver
  const favoriteBtn = document.getElementById('oneteam-like');

  // オブザーバインスタンスを作成
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      toggleLikeBtn();
    });
  });

  // オブザーバの設定
  const mutation_config = {
      attributes:true,
      subtree:true
  };

  // 対象ノードとオブザーバの設定を渡す
  observer.observe(favoriteBtn, mutation_config);

});

/* ===============================
* オプションを変更した場合の処理
=============================== */
function change_variant(){
  //ボタンラベルを取得
  let available_label = $('.cart-box .btn').attr('data-available');
  let disable_label = $('.cart-box .btn').attr('data-disable');

  //各オプション項目を取得
  let option_1 = $("#option1").val();
  if(option_1 === undefined){option_1 = null;}
  let option_2 = $("#option2").val();
  if(option_2 === undefined){option_2 = null;}
  let option_3 = $("#option3").val();
  if(option_3 === undefined){option_3 = null;}

  //商品jsonからオプションを抽出
  variant_data = product_data["variants"];
  var current_variant = variant_data.filter(function(item, index){
    if (item.option1 == option_1 && item.option2 == option_2 && item.option3 == option_3) return true;
  });
  if(current_variant.length == 0){
    var current_variant = JSON.parse(JSON.stringify(product_data["variants"]));
  }
  //オプションIDを抽出して管理用selectに反映
  var variant_id = current_variant[0].id;
  if(variant_id){
    $("#variant_id").val(variant_id);
  }

  //売切れであればボタンの表示を変更
  let current_available = current_variant[0].available;
  if(current_available){
    $('.cart-box .buy').removeClass('sold').prop('disabled',false).html(btnInnerHtml(available_label));
  }
  else{
    $('.cart-box .buy').addClass('sold').prop('disabled',true).html(btnInnerHtml(disable_label));
  }

  //初期の値段と比較
  let variant_price = current_variant[0].price/100;
  $('.detail-contents .price p').hide().html(variant_price.toLocaleString()).fadeIn();

  //SKUを置換え
  let variant_sku = current_variant[0].sku;
  $('dd[data-name="product_number"]').hide().html(variant_sku).fadeIn();

}

/* ===============================
* ボタン文字列を生成
=============================== */
function btnInnerHtml(label){
  let html = '<span class="btn-inner">';
  label.split("").forEach(function(v) {
    html += '<span>' + v + '</span>';
  });
  html += '</span>';
  return html;
}

/* ===============================
* お気に入りボタンのクラス反映
=============================== */
function toggleLikeBtn(){
  console.log('toggle like btn');
  let icon = $('.oneteam-like-button-icon');
  if(icon.hasClass('liked')){
    icon.parents('.oneteam-like-button-icon-container').addClass('liked');
  }
  else{
    icon.parents('.oneteam-like-button-icon-container').removeClass('liked');
  }
}